import { Layout as AntdLayout } from "antd";

import styled from "styled-components";
const { Content: AntdContent } = AntdLayout;

export const Layout = styled(AntdLayout)`
  height: 100%;
`;

export const Content = styled(AntdContent)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
